import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import Card from "../../../components/forms/Card";
import FormGroup from "../../../components/forms/FormGroup";
import Button from "../../../components/forms/Button";
import PdfFormSelect from "../../../components/selects/PdfFormSelect";
const PdfRiskForm = ({value, onSubmit}) => {

  const {register, handleSubmit, formState: {errors}, reset} = useForm(
    {defaultValues: value}
  );

  useEffect(() => {
    if (value) {
      reset(value)
    }
  }, [value])

  return (
    <form>
      <Card padding>

        <FormGroup>
          <label>Pdf a relacionar</label>
          <PdfFormSelect {...register("codigo", {required: "Campo obligatorio"})}/>
          {errors.codigo && <p style={{color: 'red'}}>{errors.codigo?.message}</p>}
        </FormGroup>

      </Card>

      <Button variant={'primary'} onClick={handleSubmit(onSubmit)}>Guardar</Button>
    </form>
  )
}

export default PdfRiskForm;
